module.exports = __webpack_public_path__ + "img/4.f14b7e97.jpg";